module.exports = __webpack_public_path__ + "img/image13.51d83471.png";